module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_fukushima-c121555de9e9b84f69782ff47ee10acb.png";